/* eslint-disable no-unused-vars */
import React from 'react';
import ContextMenu from 'Common/Components/ContextMenu';
import { Separator } from 'Common/Components/ContextMenu/styled';
import { useDispatch, useSelector } from 'react-redux';
import { FEATURE_CREDENTIALS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import { WithPermission } from 'Common/Components/WithPermission';
import { selectIsReadOnly } from 'store/Faraday/selectors';
import { selectShowContextMenu, selectContextMenuXPos, selectContextMenuYPos } from 'store/Credentials/selectors';
import { showContextMenu } from 'store/Credentials/actions';
import { Edit } from './components/Edit';
import { Delete } from './components/Delete';

const CredentialsContextMenu = () => {
  const dispatch = useDispatch();
  const displayContextMenu = useSelector(selectShowContextMenu);
  const xPos = useSelector(selectContextMenuXPos);
  const yPos = useSelector(selectContextMenuYPos);
  const readOnly = useSelector(selectIsReadOnly);

  if (readOnly || !displayContextMenu) return null;
  return (
    <ContextMenu
      show={ displayContextMenu }
      xPos={ xPos }
      yPos={ yPos }
      displayFunction={ (show, x, y) => dispatch(showContextMenu(show, x, y)) }
    >
      <WithPermission permission={ FEATURE_CREDENTIALS } type={ PERMISSION_TYPES.UPDATE }>
        <Edit />
      </WithPermission>
      <Separator show />
      <Delete />
    </ContextMenu>
  );
};

export default CredentialsContextMenu;
